
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.89661 6.5H5.72994C5.36215 6.50181 5.00994 6.64725 4.74987 6.90472C4.48979 7.1622 4.34288 7.51088 4.34105 7.875V12.275C4.34288 12.6391 4.48979 12.9878 4.74987 13.2453C5.00994 13.5027 5.36215 13.6482 5.72994 13.65H9.61883V13.925C9.617 14.435 9.41155 14.9236 9.0473 15.2842C8.68304 15.6448 8.18952 15.8482 7.67439 15.85C7.45337 15.85 7.24141 15.9369 7.08513 16.0916C6.92885 16.2464 6.84105 16.4562 6.84105 16.675C6.84105 16.8938 6.92885 17.1036 7.08513 17.2584C7.24141 17.4131 7.45337 17.5 7.67439 17.5C8.14861 17.5 8.61818 17.4075 9.0563 17.2279C9.49442 17.0482 9.89251 16.7849 10.2278 16.4529C10.5632 16.1209 10.8291 15.7268 11.0106 15.2931C11.1921 14.8594 11.2855 14.3945 11.2855 13.925V7.875C11.2837 7.51088 11.1368 7.1622 10.8767 6.90472C10.6166 6.64725 10.2644 6.50181 9.89661 6.5ZM9.61883 12H6.00772V8.15H9.61883V12ZM17.9522 6.5H13.7855C13.4177 6.50181 13.0655 6.64725 12.8054 6.90472C12.5454 7.1622 12.3984 7.51088 12.3966 7.875V12.275C12.3984 12.6391 12.5454 12.9878 12.8054 13.2453C13.0655 13.5027 13.4177 13.6482 13.7855 13.65H17.6744V13.925C17.6726 14.435 17.4671 14.9236 17.1029 15.2842C16.7386 15.6448 16.2451 15.8482 15.7299 15.85C15.5089 15.85 15.297 15.9369 15.1407 16.0916C14.9844 16.2464 14.8966 16.4562 14.8966 16.675C14.8966 16.8938 14.9844 17.1036 15.1407 17.2584C15.297 17.4131 15.5089 17.5 15.7299 17.5C16.6877 17.5 17.6062 17.1233 18.2834 16.4529C18.9606 15.7825 19.3411 14.8731 19.3411 13.925V7.875C19.3392 7.51088 19.1923 7.1622 18.9322 6.90472C18.6722 6.64725 18.32 6.50181 17.9522 6.5ZM17.6744 12H14.0633V8.15H17.6744V12Z","fill":"#10001F"}})])
          )
        }
      }
    